import clsx from 'clsx'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import PropTypes from 'prop-types'
import Typo from 'constants/typography'
import {
  REFERRAL_HISTORY_LOCIZE,
  REFERRAL_HISTORY_TAB,
  REFERRAL_HISTORY_BAR_TEXT,
} from 'components/referral/landing/landing-desktop/history/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { withI18next } from 'lib/i18n/withI18next'
import styles from './styles.scss'

const ReferralHistoryStatusText = ({ barText, t }) => {
  const { text, subText } = barText
  return (
    <div className="referral-history-piece__status-text">
      <span className={Typo.caption}>
        {hasLocizeTranslation(t, text.key, text.text)}
      </span>
      {subText && (
        <span className={clsx(Typo.caption, 'non-active-step')}>
          {hasLocizeTranslation(t, subText.key, subText.text)}
        </span>
      )}
    </div>
  )
}

const ReferralHistoryOrderPiece = ({ order, selectedTab, t }) => {
  const { customer_name, order_date } = order

  dayjs.extend(utc)

  return (
    <div className="referral-history-piece">
      <style jsx>{styles}</style>
      <div className="referral-history-piece__message">
        <span
          className={clsx(Typo.caption, 'referral-history-piece__message-date')}
        >
          {dayjs.utc(order_date).format('DD MMM YYYY')}
        </span>
        <span
          className={clsx(
            Typo.subtitle2,
            'referral-history-piece__message-name',
          )}
        >
          {customer_name}
        </span>
      </div>
      <div className="referral-history-piece__right">
        <div className="referral-history-piece__status">
          <ReferralHistoryStatusText
            barText={REFERRAL_HISTORY_BAR_TEXT[selectedTab]}
            t={t}
          />
          <progress
            className={selectedTab}
            value={selectedTab === REFERRAL_HISTORY_TAB.SUCCESS ? 100 : 50}
            max="100"
          />
        </div>
        <div
          className={clsx('referral-history-piece__reward', {
            incomplete: selectedTab === REFERRAL_HISTORY_TAB.IN_COMPLETE,
          })}
        >
          <span className={Typo.subtitle1}>
            {hasLocizeTranslation(
              t,
              REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_REWARD.key,
              REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_REWARD.text,
            )}
          </span>
        </div>
      </div>
    </div>
  )
}

ReferralHistoryStatusText.propTypes = {
  barText: PropTypes.shape({
    text: PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string,
    }),
    subText: PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string,
    }),
  }).isRequired,
  t: PropTypes.func.isRequired,
}

ReferralHistoryOrderPiece.propTypes = {
  order: PropTypes.shape({
    customer_name: PropTypes.string,
    order_date: PropTypes.string,
  }).isRequired,
  selectedTab: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ReferralHistoryOrderPiece)
